import { Plugin } from 'vue';

import icons from '@/assets/icons.json';

export const PROJECT_ICONS_KEY = Symbol('PROJECT_ICONS_KEY');

// import LogoIcon from '@/assets/icons/logo.svg?icon';

export const IconsPlugin = {
  install(app) {
    app.provide(PROJECT_ICONS_KEY, {
      ...icons,
      // logo: LogoIcon,
    });
  },
} as Plugin;

